<template>
  <div>
    <component
      :form="form"
      :is="input.component.name"
      :input="input"
      :rowdata="rowdata"
      :rowall="rowall"
    ></component>
  </div>
</template>

<script>
export default {
  props: ["input", "type", "form", "rowdata", "rowall"],
  components: {
    string: () => import(`../Ui/Table/string`),
    json: () => import(`../Ui/Table/string`),
    name: () => import(`../Ui/Table/name`),
    birthday: () => import(`../Ui/Table/string`),
    date: () => import(`../Ui/Table/date`),
    icon: () => import(`../Ui/Table/icon`),
    color: () => import(`../Ui/Table/color`),
    modal: () => import(`../Ui/Table/modal`),
    clickShow: () => import(`../Ui/Table/clickShow`),
    permissionModal: () => import(`../Ui/Table/permissionModal`),
    leadDetailModal: () => import(`../Ui/Table/leadDetailModal`),
    id: () => import(`../Ui/Table/id`),
    lead_id: () => import(`../Ui/Table/lead_id.vue`),
    textField: () => import(`../Ui/Table/textField`),
    leadStatus: () => import(`../Ui/Table/leadStatus.vue`),
    selectbox: () => import(`../Ui/Table/selectBox.vue`),
    status: () => import(`../Ui/Table/status`),
    integer: () => import(`../Ui/Table/integer`),
    double: () => import(`../Ui/Table/double`),
    email: () => import(`../Ui/Table/email`),
    password: () => import(`../Ui/Table/password`)
  }
};
</script>

<style></style>
